import { Dispatch, SetStateAction } from 'react';

import UserThumbnail from '@atom/components/common/UserThumbnail';
import { useNavigation } from '@atom/hooks/useNavigation';
import { List } from '@atom/mui';
import { UserResult } from '@atom/types/search';
import { highlightedText } from '@atom/utilities/textDisplayUtilities';

const { ListItemButton, ListItemText } = List;

const styles = {
  listItem: {
    paddingLeft: '1rem',
  },
  icon: {
    marginRight: '1rem',
  },
  primaryTextStyle: {
    fontWeight: 'none',
  },
};

interface Props {
  query: string;
  result: UserResult;
  setFocused: Dispatch<SetStateAction<boolean>>;
}

const UserResultItem = ({ query, result, setFocused }: Props) => {
  const [, { navigate }] = useNavigation();

  const name = highlightedText(query, `${result.firstName} ${result.lastName}`);
  const emailAddress = highlightedText(query, result.email);

  const handleNavigate = () => {
    navigate(`/team/${result.id}`);
    setFocused(false);
  };

  return (
    <ListItemButton
      key={result.id}
      onClick={handleNavigate}
      style={styles.listItem}
    >
      <div style={styles.icon}>
        <UserThumbnail image={result.photoUrl} />
      </div>
      <ListItemText
        primary={name}
        secondary={emailAddress}
        primaryTextStyle={styles.primaryTextStyle}
      />
    </ListItemButton>
  );
};

export default UserResultItem;
